<template>
  <main>
    <b-row>
      <b-col cols="6" offset="3" class="pt-4 mt-4"> 
        <div class="login-box">
          <a class="logo"><img src="/images/logo-mynd.svg" alt="Mynd - Context Mining" /></a>
          <h2 class="tagline">Please Update your password<br>to continue using Mynd!</h2>
          <!--<ul class="pb-2">
            <li>Must be between 6-20 chars long</li>
            <li>Allowed Special Characters are: !_-</li>
          </ul>-->
          <b-form @submit.prevent="submit">
            <b-form-group
              id="fieldset-1"
              description=""
              label="New password"
              label-for="input-2"
            >
              <b-form-input v-validate="{ required: true, min:6, max:20 }" type="password" id="input-1" name="password" v-model="form.password" trim></b-form-input>
            </b-form-group>
            <b-form-group
              id="fieldset-2"
              description=""
              label="Confirm new password"
              label-for="input-2"
            >
              <b-form-input v-validate="{ required: true, min:6, max:20 }" type="password" id="input-2" name="confirm password" v-model="form.password1" :state="validation" trim></b-form-input>
              <b-form-invalid-feedback v-if="form.password1" :state="validation">
                Your password doesnt match!
              </b-form-invalid-feedback>
              <b-form-valid-feedback v-if="form.password1" :state="validation">
                Password Matched!
              </b-form-valid-feedback>
            </b-form-group>
            <div class="d-flex">
              <b-button type="submit" variant="primary" :disabled="!validation">Submit</b-button>
              <!--<a :to="{ name: 'Login' }" class="sidelink">Back to Login</a>-->
            </div>
          </b-form>
        </div>
      </b-col>
    </b-row>
  </main>
</template>

<script>
import { mapActions } from 'vuex';
export default {
  name: 'UpdatePassword',
  data() {
    return {
      form: {
        password: '',
        password1: ''
      },
      company: null
    };
  },
  computed: {
    validation(){
      return this.form.password === this.form.password1
    }
  },
  mounted() {
    this.company = localStorage.getItem('company') || null
  },
  methods: {
    ...mapActions(['savePasswordStatus', 'updatePass']),
    async submit() {
      //const User = new FormData();
      //User.append('email', 'usmannut@gmail.com');
      //User.append('password', this.form.password);
      this.$validator.validateAll().then(result => {
        if (!result) {
          this.$toasted.show(this.$validator.errors.items[0].msg, {
            type: "error"
          });
          return;
        }
        else{
          /*
          this.$toasted.show("All Good", {
            type: "success"
          });
          */
          this.updatePass({'password': this.form.password}).then(res => {
            this.savePasswordStatus(res.passwordSecure);
            this.$router.push("/projects");
          })
        }
      });
    }
  }
}
</script>